import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';

import { MessageBoxType, SnackbarConfig } from './models';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIcon } from '@angular/material/icon';
import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { MatIconButton, MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatIcon, NgIf, NgSwitch, NgSwitchCase, MatIconButton, NgSwitchDefault, MatButton, TranslateModule],
})
export class ToastComponent implements OnInit {
  constructor(
    private snackBarRef: MatSnackBarRef<ToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarConfig
  ) {}

  iconType!: string;
  iconColor!: string;

  callBackAction = () => {};

  ngOnInit(): void {
    document.documentElement.style.setProperty('--type', this.getColor(this.data.type));
    if (this.data.callBack) {
      this.callBackAction = this.data.callBack;
    }
  }

  public dismiss(action?: number): void {
    if (action) {
      this.snackBarRef.dismissWithAction();
    } else {
      this.snackBarRef.dismiss();
    }
  }

  private getColor(type: MessageBoxType) {
    if (type === MessageBoxType.PRIMARY) {
      this.iconType = 'ic-info';
      this.iconColor = '#E60000';
    } else if (type === MessageBoxType.INFO) {
      this.iconType = 'ic-info';
      this.iconColor = '#24bbfa';
    } else if (type === MessageBoxType.SUCCESS) {
      this.iconType = 'ic-success';
      this.iconColor = '#2F9803';
    } else if (type === MessageBoxType.WARNING) {
      this.iconType = 'ic-warning-caution';
      this.iconColor = '#f8ca3c';
    } else if (type === MessageBoxType.DANGER) {
      this.iconType = 'ic-error';
      this.iconColor = '#E60000';
    }
    return this.iconColor;
  }
}
